module.exports = __webpack_public_path__ + "static/img/Image_Recolor.8b9e0dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Image_Recolor.jpg
// module id = oPIC
// module chunks = 1